<template>
  <div
    class="min-h-screen flex items-center justify-center bg-[var(--login-bg)] px-4"
  >
    <div
      :class="[
        'relative w-full max-w-[900px] h-auto md:h-[600px] rounded-3xl shadow-2xl overflow-visible flex flex-col',
        locale === 'ar' ? 'md:flex-row-reverse' : 'md:flex-row',
      ]"
    >
      <!-- Tilted Primary Rectangle (Hidden on mobile) -->
      <div
        class="hidden md:block absolute top-0 left-0 w-[910px] h-[600px] transform rotate-3 bg-[var(--primary)] z-0 rounded-3xl"
      ></div>

      <!-- Background Image -->
      <div class="absolute inset-0 z-10 rounded-3xl overflow-hidden">
        <img
          src="@/assets/Login/loginbg.png"
          alt="Food"
          :class="[
            'object-cover w-full h-full brightness-[0.6]',
            locale === 'ar' ? 'rtl-flip' : '',
          ]"
        />
      </div>

      <!-- Content Layer -->
      <div class="relative z-20 flex flex-col md:flex-row w-full h-full">
        <!-- Left: Image & Logo (Hidden on small screens) -->
        <div class="relative hidden md:flex w-1/2 p-6 flex-col justify-between">
          <router-link
            :class="['absolute top-6', locale === 'ar' ? 'right-6' : 'left-6']"
            to="/"
          >
            <img
              src="@/assets/logo.png"
              alt="Logo"
              class="w-[64px] h-[64px] md:w-[96px] md:h-[96px] object-contain cursor-pointer"
            />
          </router-link>

          <div
            class="absolute bottom-10 left-8 right-8 text-[var(--on-surface)] text-lg"
          >
            <div
              class="bg-[color-mix(in_srgb,#fff_10%,transparent)] backdrop-blur-md p-6 rounded-tl-[3rem] rounded-br-[3rem] rounded-tr-lg rounded-bl-lg max-w-md text-center mx-auto"
            >
              <p class="text-[22px] font-normal text-white leading-snug">
                {{ $t("login.welcome") }}
              </p>
            </div>
          </div>
        </div>

        <!-- Right: Login Form -->
        <div class="w-full md:w-[60%] flex items-center justify-center p-6">
          <div
            class="relative isolate w-full max-w-[500px] min-h-[600px] bg-[var(--surface)] p-6 sm:p-4 rounded-2xl shadow-[var(--form-glow)] hover:shadow-[var(--form-glow-strong)] transition-shadow duration-300 [filter:var(--form-drop-glow)]"
          >
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.font-cursive {
  font-family: "Brush Script MT", cursive;
}
.rtl-flip {
  transform: scaleX(-1);
}
</style>

<script setup>
import LoginForm from "@/components/LoginForm.vue";
import { useI18n } from "vue-i18n";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const { locale } = useI18n();
const router = useRouter();
const auth = getAuth();

// Check if user is already logged in
onMounted(() => {
  onAuthStateChanged(auth, (user) => {
    if (user && user.emailVerified) {
      // User is already logged in and email verified, redirect to booking duration
      router.push("/bookingduration");
    }
  });
});
</script>
